// extracted by mini-css-extract-plugin
module.exports = {"sort":"AX","sortSelect":"BX","disabled":"CX"};